import React, { useEffect, useState, useCallback } from 'react';
import { eventApi } from '../../services/api';
import { useWebSocket } from '../../hooks/useWebSocket';
import './EventLog.css';
const ICONS: Record<string,string> = { motion:'🚨', ai_detection:'🤖', system:'⚙️', auth:'🔐' };
export default function EventLog() {
  const [events, setEvents] = useState<any[]>([]);
  useEffect(() => { eventApi.list().then(({ data }) => setEvents(data.results || data)); }, []);
  const handleWs = useCallback((msg: any) => { if (msg.type === 'new_event') setEvents(p => [msg.event, ...p].slice(0,50)); }, []);
  useWebSocket(handleWs);
  return (
    <div className="el-wrap">
      <div className="el-header"><span className="el-title">SON HADİSƏLƏR</span><span className="el-count">{events.length}</span></div>
      <div className="el-list">
        {events.map(ev => (
          <div key={ev.id} className="el-item">
            <div className={`el-icon ${ev.event_type}`}>{ICONS[ev.event_type] || '•'}</div>
            <div className="el-body"><div className="el-etitle">{ev.title}</div><div className="el-detail">{ev.camera_name}{ev.confidence ? ` · ${Math.round(ev.confidence)}%` : ''}</div></div>
            <div className="el-time">{new Date(ev.timestamp).toLocaleTimeString('az-AZ',{hour:'2-digit',minute:'2-digit'})}</div>
          </div>
        ))}
        {!events.length && <div className="el-empty">Hadisə yoxdur</div>}
      </div>
    </div>
  );
}
